export type RegionEndpointVariableValue = {
  internal: string;
  public: string;
};

export type HelpdeskMenuItem = {
  name: string;
  path: string;
};

const isNonArrayObject = (v: unknown): v is Record<string, unknown> =>
  Boolean(v) && typeof v === 'object' && !Array.isArray(v);

const isHelpdeskMenuItem = (v: unknown): v is HelpdeskMenuItem => {
  if (!isNonArrayObject(v)) {
    return false;
  }
  return typeof v.name === 'string' && typeof v.path === 'string';
};

export const HELPDESK_VARIABLE_KEY = 'helpdesk';

export const isRegionEndpointVariableKey = (key: string) =>
  key.startsWith('kr-central-') || key.startsWith('kr-gov-central-');

export const parseVariableJsonValue = <T>(
  raw: string | undefined,
  refine: (parsed: unknown) => T | undefined,
): T | undefined => {
  const trimmed = raw?.trim();
  if (!trimmed) {
    return undefined;
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return undefined;
  }
  return refine(parsed);
};

export const parseRegionEndpointVariableValue = (raw: string | undefined) =>
  parseVariableJsonValue<RegionEndpointVariableValue>(raw, parsed => {
    if (!isNonArrayObject(parsed)) {
      return undefined;
    }
    return {
      internal: typeof parsed.internal === 'string' ? parsed.internal : '',
      public: typeof parsed.public === 'string' ? parsed.public : '',
    };
  });

export const parseHelpdeskMenuVariableValue = (raw: string | undefined) =>
  parseVariableJsonValue<HelpdeskMenuItem[]>(raw, parsed => {
    if (!Array.isArray(parsed) || !parsed.every(isHelpdeskMenuItem)) {
      return undefined;
    }
    return parsed;
  });
